import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { catchError, map, shareReplay } from 'rxjs/operators'

const GATEKEEPER_PATH = 'vmf/api/gatekeeper'

// Feature id registered in Gatekeeper for the TRJ product-profile link.
export const PRODUCT_PROFILE_TRJ_LINK = 'productProfileEnableTRJLink'

interface GatekeeperResponse {
  features: Record<string, boolean>
}

@Injectable({
  providedIn: 'root',
})
export class GatekeeperService {
  private readonly gatekeeperObservable: Observable<GatekeeperResponse>

  constructor(private readonly http: HttpClient) {
    this.gatekeeperObservable = this.http
      .get<GatekeeperResponse>(GATEKEEPER_PATH)
      .pipe(
        // One shared request for all subscribers; fail closed on error.
        catchError(() => of({ features: {} } as GatekeeperResponse)),
        shareReplay(),
      )
  }

  public isFeatureEnabled(featureId: string): Observable<boolean> {
    return this.gatekeeperObservable.pipe(
      map((response) => response.features?.[featureId] ?? false),
    )
  }
}
